import { FeatureGenqlSelection } from "@/gql/gen";

export const FeatureFields: FeatureGenqlSelection = {
    ID: true,
    NAME: true,
    CODE: true,
    SORT: true,
    ACTIVE: true,
    PREVIEW_TEXT: true,
    DETAIL_TEXT: true,
    AVAILABLE: {
        STATUS: true,
        REASON: true
    },
    PROPERTIES: {
        SCHEDULE_ENABLE: true,
        SCHEDULE: true
    }
}




